import type { IIconProps } from '@app/components/Icon/types'

interface IIconLandingPageProps extends IIconProps {}

export default function IconLandingPage(props: IIconLandingPageProps) {
  const size = props.size ?? 20

  return (
    <svg
      className={props.className}
      width={size}
      height={size}
      color={props.color}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6416 14.359V16.7859C15.6416 17.5292 15.039 18.1318 14.2957 18.1318H5.67794C4.95289 18.1318 4.36511 17.544 4.36511 16.819V3.29418C4.36511 2.50267 5.00676 1.86102 5.79827 1.86102H14.2348C15.0117 1.86102 15.6416 2.49085 15.6416 3.26777V6.87095"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89844 4.36102H10.676"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8917 9.47852L13.1162 13.254L11.1291 11.2669L8.14844 14.2476M16.8917 9.47852H14.5072M16.8917 9.47852V11.863"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
